import script from "./application.vue?vue&type=script&setup=true&lang=js"
export * from "./application.vue?vue&type=script&setup=true&lang=js"

import "./application.vue?vue&type=style&index=0&id=9bfb3e1a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bfb3e1a"]])

export default __exports__